import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	LWApiPublicNetworkCdnZoneListResultRawI,
	type LWApiPublicNetworkCdnZoneListParamsRawI,
} from '@liquidweb-dev/club-sauce/public/network/cdn/zone.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_CDN_ZONE_LIST_QUERY_KEY = '/network/cdn/zone/list';

const useNetworkCdnZoneList = (
	params: LWApiPublicNetworkCdnZoneListParamsRawI,
	options?: UseQueryOptions<LWApiPublicNetworkCdnZoneListResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [NETWORK_CDN_ZONE_LIST_QUERY_KEY, params],
		queryFn: () => api.network.cdn.zone.apiRaw.list(params),
		...options,
	});

export default useNetworkCdnZoneList;
